import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, takeEvery } from "redux-saga/effects";
import * as actions from "../actions";
import * as constants from "../constants";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchLoginOptions() {
  try {
    const response = yield axios.get(
      `${baseURL}/api/v2/admin/auth/fetch-login-options`
    );

    const { success, data, message } = response.data;

    if (success) {
      yield put(actions.fetchLoginOptionsSuccess(data));
    } else {
      AntdAlert.error(message || "Failed to fetch login options.");
      yield put(actions.fetchLoginOptionsError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.error("Fetch Login Options Error:", error);
    AntdAlert.error("Error fetching login options.");
    yield put(actions.fetchLoginOptionsError());
  }
}

export function* handleCreateLoginOptions({ data }) {
  try {
    const response = yield axios.post(
      `${baseURL}/api/v2/admin/auth/login-options`,
      {
        login_details: data,
      }
    );

    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message || "Login options updated successfully.");
      yield put(actions.createLoginOptionsSuccess(response.data.data));
    } else {
      AntdAlert.error(response.data?.errors?.[0] || "Something went wrong.");
      yield put(actions.createLoginOptionsError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.error("Login Options Error:", error);
    AntdAlert.error("Failed to update login options.");
    yield put(actions.createLoginOptionsError());
  }
}

export function* watcherLoginOptionsSaga() {
  yield takeEvery(constants.FETCH_LOGIN_OPTIONS, handleFetchLoginOptions);
  yield takeEvery(constants.CREATE_LOGIN_OPTIONS, handleCreateLoginOptions);
}
